module.exports = __webpack_public_path__ + "img/government-Industry-points1.6ae52160.png";